import logoDefault from '../assets/images/logo/logo-sm.20211204-2.png';
import logoWhite from '../assets/images/logo/logo.202104212035-white.png';
import logoMobile from '../assets/images/logo/logo-sm.202104212035.jpg';
import isDev from '@/config/isDev';

export default {
    data() {
        return {
            logoDefault,
            logoWhite,
            logoMobile,
        }
    },
    computed: {
        isDev() {
            return isDev;
        }
    }
}